if (!customElements.get('bl-mobile-purchase')) {
  customElements.define('bl-mobile-purchase', class extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('[data-mobile-submit]');
      this.buttonText = this.querySelector('[data-mobile-submit-text]');
      this.price = this.querySelector('[data-mobile-price]');
      this.quantity = this.querySelector('[data-mobile-quantity]');
      this.variant = this.querySelector('[data-mobile-variant]');
      this.error = this.querySelector('[data-mobile-error]');
      this.onClick = this.submit.bind(this);
      this.onInput = this.sync.bind(this);
      this.onOptions = (event) => {
        const picker = this.source?.querySelector('variant-selects');
        if (!picker) return;
        event.preventDefault();
        picker.scrollIntoView({ block: 'center', behavior: 'smooth' });
        const option = picker.querySelector('select, input:checked, input');
        option?.focus({ preventScroll: true });
      };
      this.button.addEventListener('click', this.onClick);
      this.querySelector('[data-mobile-options]')?.addEventListener('click', this.onOptions);
      this.onLoaded = () => this.bindSource();
      document.addEventListener('product-info:loaded', this.onLoaded);
      this.bindSource();
      this.resizeObserver = new ResizeObserver(() => {
        if (this.getBoundingClientRect().height) {
          document.documentElement.style.setProperty('--bl-mobile-purchase-height', `${this.getBoundingClientRect().height}px`);
        }
      });
      this.resizeObserver.observe(this);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.resizeObserver?.disconnect();
      this.intersectionObserver?.disconnect();
      this.source?.removeEventListener('input', this.onInput);
      this.source?.removeEventListener('change', this.onInput);
      this.button.removeEventListener('click', this.onClick);
      this.querySelector('[data-mobile-options]')?.removeEventListener('click', this.onOptions);
      document.removeEventListener('product-info:loaded', this.onLoaded);
    }

    bindSource() {
      const source = document.getElementById(`MainProduct-${this.dataset.section}`);
      if (source === this.source) return;
      this.observer?.disconnect();
      this.intersectionObserver?.disconnect();
      this.source?.removeEventListener('input', this.onInput);
      this.source?.removeEventListener('change', this.onInput);
      this.source = source;
      if (!source) {
        this.hidden = true;
        return;
      }
      this.hidden = false;
      source.addEventListener('input', this.onInput);
      source.addEventListener('change', this.onInput);
      this.observer = new MutationObserver(() => this.sync());
      this.observer.observe(source, {
        subtree: true, childList: true, characterData: true,
        attributes: true, attributeFilter: ['disabled', 'aria-disabled', 'hidden', 'class', 'value']
      });
      const nativeButton = source.querySelector(`[id="ProductSubmitButton-${this.dataset.section}"]`);
      this.intersectionObserver = new IntersectionObserver(([entry]) => {
        this.classList.toggle('bl-mobile-purchase--native-visible', entry.isIntersecting && entry.intersectionRatio === 1);
      }, { threshold: 1, rootMargin: '-100px 0px -12px 0px' });
      if (nativeButton) this.intersectionObserver.observe(nativeButton);
      this.sync();
    }

    sync() {
      const form = document.getElementById(this.dataset.formId);
      const nativeButton = this.source?.querySelector(`[id="ProductSubmitButton-${this.dataset.section}"]`);
      if (!form || !nativeButton) {
        this.button.disabled = true;
        return;
      }
      const loading = nativeButton.getAttribute('aria-disabled') === 'true';
      this.button.disabled = nativeButton.disabled || loading;
      this.button.setAttribute('aria-busy', String(loading));
      const text = nativeButton.querySelector('span')?.textContent.trim();
      if (text && this.buttonText.textContent !== text) this.buttonText.textContent = text;
      const priceRoot = this.source.querySelector(`[id="price-${this.dataset.section}"]`);
      const currentPrice = priceRoot?.querySelector('.price--on-sale .price-item--sale, .price:not(.price--on-sale) .price-item--regular');
      if (currentPrice) this.price.textContent = currentPrice.textContent.trim();
      const quantity = form.elements.namedItem('quantity');
      this.quantity.textContent = `${this.dataset.quantityLabel}: ${quantity?.value || 1}`;
      const variantData = this.source.querySelector('variant-selects [data-selected-variant]');
      if (this.variant && variantData) {
        try {
          const selected = JSON.parse(variantData.textContent);
          this.variant.textContent = selected?.title || text;
        } catch (error) {
          this.button.disabled = true;
        }
      }
      const nativeError = form.closest('product-form')?.querySelector(
        '.product-form__error-message-wrapper:not([hidden]), .product-form__recipient-error-message-wrapper:not([hidden])'
      );
      const message = nativeError?.innerText.trim() || '';
      if (this.error.textContent !== (message || '')) this.error.textContent = message || '';
      this.error.hidden = !message;
    }

    submit(event) {
      event.preventDefault();
      this.sync();
      const form = document.getElementById(this.dataset.formId);
      const nativeButton = this.source?.querySelector(`[id="ProductSubmitButton-${this.dataset.section}"]`);
      if (this.button.disabled || !form || !nativeButton) return;
      if (!form.reportValidity()) return;
      nativeButton.click();
      this.sync();
    }
  });
}
